<template>
  <!-- Бренд товара: названием (стиль из админки → Сайт → Бренды и дисклеймеры, блок «All manufacturers»)
       или логотипом, если там выбрано «Логотипами». -->
  <span v-if="asText" :class="['brand-mark', 'brand-name', 'brand-name--' + textStyle]" :style="{ fontSize: size + 'px' }"
        v-html="label"></span>
</template>

<script>
import {useSiteSettings} from "@/functions/siteSettings";

const STYLES = ["light", "bold", "spaced", "large", "accent", "manrope"];

export default {
  props: {
    name: { type: String, default: "" },
    image: { type: String, default: "" },
    /** Базовый размер шрифта в px (стиль масштабирует его). */
    size: { type: Number, default: 11 },
  },
  setup() {
    return { catalog: useSiteSettings("catalog") };
  },
  computed: {
    asText() {
      return true; // только названия, логотипы брендов не используются
    },
    textStyle() {
      const s = this.catalog?.brandsPageStyle;
      return STYLES.includes(s) ? s : "light";
    },
    label() {
      const esc = String(this.name ?? "").toUpperCase()
          .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
      return esc.replace(/\+/g, "+<wbr>");
    },
  },
};
</script>

<style scoped>
.brand-mark {
  max-width: 100%;
  padding: 0 4px;
}
.brand-mark.brand-name--accent::after {
  width: 14px;
  height: 2px;
  margin-top: 3px;
}
</style>
